<template>
  <div>入库单列表</div>
</template>

<script>
export default {
  name: "index"
}
</script>

<style scoped>

</style>